import { InjectionToken } from '@angular/core';

/**
 * Origins the `/live-preview/` bridge accepts incoming messages from, and the only ones it posts to.
 *
 * An empty allowlist disables the bridge instead of falling back to `'*'`: the preview renders
 * unpublished page content, so a wrong or wildcard origin would leak it to any embedding page.
 */
export const LIVE_PREVIEW_ALLOWED_ORIGINS = new InjectionToken<string[]>('Live preview allowed origins');
